import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Avis {
  id: number;
  circularName: string;
  docName: string;
  path: string;
  description: string;
  vu: string;
  nbrCirculaires: number;
  creationDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class AvisService {
  private baseUrl = `${environment.apiUrl.replace(/\/$/, '')}/administrativDocument`;

  constructor(private http: HttpClient) {}

  getStudentAvis(idBatch: number, numberPage: number, sizePage: number): Observable<any> {
    const url = `${this.baseUrl}/listAdministrativDocumentBatch/${idBatch}/${numberPage}/${sizePage}`;
    return this.http.get<any>(url).pipe(
      tap(response => console.log('Student Avis Response:', response))
    );
  }
  
}
